import { render, staticRenderFns } from "./MyInvest.vue?vue&type=template&id=a3d25716&scoped=true&"
import script from "./MyInvest.vue?vue&type=script&lang=js&"
export * from "./MyInvest.vue?vue&type=script&lang=js&"
import style0 from "./MyInvest.vue?vue&type=style&index=0&id=a3d25716&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d25716",
  null
  
)

export default component.exports